import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { NgbActiveModal, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import {Observable, Subject} from 'rxjs';
import { tourHolidayTypeList } from 'src/app/modules/booking-flow/holiday/holiday-search-page/helpers/holiday-types';
import fixArray from '../../../../utils/fixArray';
import { IPrefetchDateParams } from '../../../shared/interfaces/iprefetch-date-params';
import { HolidayPrefetchService } from '../../../shared/services/holiday-prefetch.service';
import { MobileService } from '../../../shared/services/mobile.service';
import { IDestinationBoxElement } from '../../interfaces/idestination-box-element';
import { IEngineParamChange } from '../../interfaces/iengine-param-change';
import { EngineTabTypes } from '../../models/engine-tab-types.enum';
import * as dayjs from 'dayjs';
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-engine-tour-modal-datepicker',
  templateUrl: './engine-tour-modal-datepicker.component.html',
  styleUrls: ['./engine-tour-modal-datepicker.component.scss']
})
export class EngineTourModalDatepickerComponent implements OnInit, OnDestroy {

  @Input() selectedDestination: IEngineParamChange<IDestinationBoxElement>;
  @Input() selectedTour: IEngineParamChange<number>;
  @Input() onlyCustomHoliday: boolean;
  @Output() selectedDate = new EventEmitter<IEngineParamChange<NgbDateStruct>>();
  @Input() defaultDate: string;
  @Input() engineTabType: EngineTabTypes;

  private _destroy$ = new Subject<boolean>();

  prefetchDate: Observable<any>;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  availableDates: NgbDate[];
  selectedDateInternal: NgbDateStruct;
  loadingStatus: boolean;
  loadingMessage: string;
  isMobile$: Observable<boolean>;
  modal = this._activeModal;

  constructor(private _activeModal: NgbActiveModal,
              private _holidayPrefetchService: HolidayPrefetchService,
              private _mobileService: MobileService) { }

  ngOnInit(): void {
    this.minDate = {year: dayjs().year(), month: dayjs().month() + 1, day: dayjs().date()};

    if (this.selectedDestination?.resetParams || this.selectedTour?.resetParams) {
      this.selectDate(undefined);
    }
    if (this.selectedDestination?.value || this.selectedDestination?.id || this.selectedTour?.value) {
      this.prefetchDate = this._holidayPrefetchService.prefetchDate( this._preparePrefetchPrams());
       this.prefetchDate.pipe(takeUntil(this._destroy$)).subscribe(e => {
        if (e && e.length > 0) {
          this.availableDates = e.map(d => d.split('-').map(i => parseInt(i, 10))).map(d => new NgbDate(d[0], d[1], d[2]));
          this.minDate = this.availableDates[0];
          this.maxDate = this.availableDates[this.availableDates.length - 1];
        }
      });
      this.isMobile$ = this._mobileService.isMobile();
    }
    if (this.defaultDate) {
      const tmpDate = this.defaultDate.split('-').map(i => parseInt(i, 10));
      this.selectDate(new NgbDate(tmpDate[0], tmpDate[1], tmpDate[2]), false);
    }
  }

  private _preparePrefetchPrams(): IPrefetchDateParams {
    return {
      destination: this.selectedDestination?.value?.id ? fixArray(this.selectedDestination.value.id) : undefined,
      tours: this.selectedTour?.value ? fixArray(this.selectedTour.value) : undefined,
      departurePlace: undefined,
      onlyCustomHoliday: this.onlyCustomHoliday,
      holidayTypeList: tourHolidayTypeList
    };
  }

  selectDate(date: NgbDate, resetParams: boolean = true): void {
    this.selectedDateInternal = date;
    this.selectedDate.emit({value: date, resetParams});

  }

  onDateSelected(date: NgbDate): void {
    this.selectDate(date);
    this._activeModal.dismiss();
  }

  isDisabledDate = (date: NgbDate) => {
      return this.availableDates ? !this.availableDates.some(e => e.equals(date)) : true;
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
